export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10012.2af602a7.jpg";